import Swiper from "swiper/bundle";
import "swiper/css/bundle";

function initPostsSlider() {
  const swiper = new Swiper(".posts-slider", {
    slidesPerView: 1.2,
    spaceBetween: 16,
    navigation: {
      nextEl: ".posts-slider-next",
      prevEl: ".posts-slider-prev",
    },
    breakpoints: {
      600: {
        slidesPerView: 2.1,
      },
      900: {
        slidesPerView: 3.1,
      },
      1200: {
        slidesPerView: 4,
      },
    },
  });
}

export { initPostsSlider };

function initFeedbackSlider() {
  const swiper = new Swiper(".feedback-slider", {
    slidesPerView: 1.1,
    spaceBetween: 16,
    navigation: {
      nextEl: ".feedback-slider-next",
      prevEl: ".feedback-slider-prev",
    },
    breakpoints: {
      600: {
        slidesPerView: 1.3,
      },
      900: {
        slidesPerView: 2.3,
      },
      1200: {
        slidesPerView: 3,
      },
    },
  });
}

export { initFeedbackSlider };
